import React, { Component } from 'react'
import { withStyles, Typography, Chip } from '@material-ui/core';
import AlertDiv from '../Forms/AlertDiv';
import { orange } from '@material-ui/core/colors';
import { GetData } from '../../../api/service';

const styles = theme => ({

})

class FinalSubmitForm extends Component {
  state = {
    email: ''
  }

  componentDidMount() {
    // check for status update

    GetData(`/${this.props.form_id}/admissionform/haspaymentdonep`)
      .then((resp) => {
        //console.log(resp)
        //if (resp) {
          this.props.history.replace('/final')
       // }
      })
  }

  render() {
    let { classes } = this.props;
    return (
      <div>
        {/* <AlertDiv
          back={orange[100]}
          border={orange[400]}
        >
          <Typography
            variant="h5"
          >
            Your form fill up complete.
            </Typography>

          <br />

          <Typography
            variant="h6"
            gutterBottom
          >
            Your Application Form No is: <Chip color="primary" label={this.props.form_id} />
          </Typography>
         
          <br />


        </AlertDiv> */}
      </div>
    )
  }
}

export default withStyles(styles)(FinalSubmitForm)